export const DrawerTestAttributes = {
    title: 'drawer-title',
    titleText: 'drawer-title-text',
    titleDescription: 'drawer-title-description',
    titleAvatar: 'drawer-title-avatar',
    titleIcon: 'drawer-title-icon',
};
